import jwt from 'jsonwebtoken';
import { getConfig } from '../util/helper';
import { getUserRbac } from './rbac';

const getUserToken = (servico = 'corporate') => {
  try {
    const nsCorporateUser = sessionStorage.getItem('_nscorporate_user');
    return nsCorporateUser ? JSON.parse(nsCorporateUser).tokens[servico] : '';
  } catch (error) {
    return null;
  }
};

const getLoggedUserCKV = async () => {
  const config = await getConfig();
  const token = getUserToken('Authenticated');
  const decodedToken = jwt.decode(token);
  if (!decodedToken) return;

  const { ckv } = decodedToken;

  if (!ckv || !ckv.length) return;
  const { dados } = ckv.find(({ client }) => client === config.idCliente);

  if (!dados || !dados.length) return;

  return dados;
};

const getLoggedUserRBAC = async () => {
  const token = getUserToken('Authenticated');
  const decodedToken = jwt.decode(token);
  if (!decodedToken) return;

  let { rbac } = decodedToken;

  if (!rbac || !rbac.length) {
    rbac = await getUserRbac();
    if (!rbac || !rbac.length) return;
  }
  return rbac;
};

const getLoggedUserRoles = async () => {
  const rbac = await getLoggedUserRBAC();
  if (!rbac) return [];
  return rbac.reduce((acc, { roles }) => [...acc, ...roles], []);
};

export {
  getUserToken,
  getLoggedUserCKV,
  getLoggedUserRBAC,
  getLoggedUserRoles,
};
